// extracted by mini-css-extract-plugin
module.exports = {"report-sign":"report-sign-b0b4664ade51653e8be35912eb9069e6"};